import { Component } from 'react';
import PropTypes from 'prop-types';
import { NavMarker } from 'react-rhumb';
import { connect } from 'react-redux';
import { stringify } from 'hub-http/helpers/params';
import TwoFactorAuthForm from './TwoFactorAuthForm';
import RememberThisDeviceV3 from '../legacyLogins/two-factor-auth/RememberThisDevice';
import { RememberThisDevice as RememberThisDeviceV4 } from './RememberThisDevice';
import { extractRedirectQueryParams } from '../../lib/LoginUtils';
import { switchTwoFactorMethod as switchTwoFactorMethodAction, updateTotp, startVerifying, finishVerifying, startRequestingCode as startRequestingCodeAction, startRequestingTwoFactorCall as startRequestingTwoFactorCallAction, finishRequestingTwoFactorCall as finishRequestingTwoFactorCallAction, finishRequestingCode as finishRequestingCodeAction, showNewCodeSentAlert as showNewCodeSentAlertAction, showCodeCallAlert as showCodeCallAlertAction, toggleRememberDevice as toggleRememberDeviceAction, switchAppState as switchAppStateAction, toggleRememberDeviceModal } from '../../actions';
import { resetPage, handle2faLoginSuccess, handle2faLoginFailure, requestHubspotAppStatus, updateHubspotAppStatus } from '../../actions/twoFactorAuth';
import TwoFactorAuthMethods from '../../constants/TwoFactorAuthMethods';
import TwoFactorAuthAppStates from '../../constants/TwoFactorAuthAppStates';
import TwoFactorAuthHSAppStatuses from '../../constants/TwoFactorAuthHSAppStatuses';
import { isPrimaryMethod as getIsPrimaryMethod, getTwoFactorLevel, hasSecondaryMethod as getHasSecondaryMethod, getToken, getTwoFactorMethod, getIsVerifying, getIsRequestingCode, getTotp, getEmail, getPassword, getRememberThisDevice, getBackupCodesEnabled, getAppState, getAreBothGoogleAuth, getRememberLogin, isHubspotAuthRequestResponded, getIsLoginWithHSPrompt } from '../../selectors/TwoFactorAuth';
import TwoFactorLoginDao from '../../data/TwoFactorLoginDao';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { loginVerificationWithHSAuthInitiated, loginVerificationWithHSAuthCodeInitiated, loginVerificationWithHSAuthCodeAccomplished, trackRememberThisDevice, trackDoNotRememberThisDevice } from 'LoginUI/lib/tracker';
import { get2faLoginObject } from '../../utils/twoFactorLoginObject';
import { setToken } from '../../actions';
import { getIsChatSpot, getIsConnect } from '../../utils/urls';
import { getIsUngatedForLoginV4 } from '../../utils/loginMetadataCookie';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const twoFactorDao = new TwoFactorLoginDao();
const TIME_OUT_STOP = 120000;
const INTERVAL = 3000;
class TwoFactorAuth extends Component {
  constructor(props) {
    super(props);
    this.startPolling = () => {
      const {
        history,
        token = ''
      } = this.props;
      const setModalTimer = setTimeout(() => {
        if (this.props.hubspotAppResponded) {
          return clearTimeout(setModalTimer);
        } else {
          return this.props.updateHubspotAppStatus(TwoFactorAuthHSAppStatuses.INVALID);
        }
      }, TIME_OUT_STOP);
      const fetchWithInterval = setInterval(() => {
        if (this.props.hubspotAppResponded) {
          return clearInterval(fetchWithInterval);
        } else {
          return this.props.requestHubspotAppStatus(token, fetchWithInterval, setModalTimer, history);
        }
      }, INTERVAL);
      setTimeout(() => {
        return clearInterval(fetchWithInterval);
      }, TIME_OUT_STOP);
    };
    this.restartTimer = () => {
      this.props.updateHubspotAppStatus();
      const {
        token = '',
        isPrimaryMethod
      } = this.props;
      twoFactorDao.resendTwoFactor(token, isPrimaryMethod).catch(err => this.props.handle2faLoginFailure(err, this.props.history));
      this.startPolling();
    };
    this.onCodeChange = e => {
      this.props.updateTotp(e.target.value);
    };
    this.onLostDevice = () => {
      const {
        canUseAdminRecovery
      } = this.props;
      if (canUseAdminRecovery) {
        this.props.history.push('/two-factor/recovery');
      } else {
        this.props.history.push('/two-factor/recovery-support');
      }
    };
    this.twoFactorMethodIs = methods => {
      const {
        twoFactorMethod
      } = this.props;
      return twoFactorMethod && methods.includes(twoFactorMethod.method);
    };
    this.trackAndVerify = () => {
      if (this.twoFactorMethodIs([TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR])) {
        loginVerificationWithHSAuthCodeInitiated();
      }
      this.props.startVerifying();
    };
    this.twoFactorSubmit = opts => {
      const {
        loginPortalId,
        loginRedirectUrl,
        autoRedirectGoogle
      } = this.state;
      const {
        email,
        password,
        totp = '',
        twoFactorLevel,
        appState,
        rememberLogin,
        token,
        twoFactorMethod,
        isLoginWithHSPrompt
      } = this.props;
      const {
        rememberThisDevice
      } = opts;
      const credentials = {
        email,
        password,
        token,
        verificationCode: totp.replace(/\s+/g, ''),
        loginPortalId,
        loginRedirectUrl,
        autoRedirectGoogle,
        twoFactorLevel,
        isBackupCodeRequest: appState === TwoFactorAuthAppStates.BACKUP,
        shouldRememberThisDevice: rememberThisDevice,
        rememberLogin
      };
      const loginObject = get2faLoginObject(twoFactorMethod.method, twoFactorDao, isLoginWithHSPrompt);
      this.trackAndVerify();
      if (rememberThisDevice) {
        trackRememberThisDevice();
      } else {
        trackDoNotRememberThisDevice();
      }
      loginObject.login(credentials).then(resp => {
        if (this.twoFactorMethodIs([TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR])) {
          loginVerificationWithHSAuthCodeAccomplished();
        }
        this.props.handle2faLoginSuccess(resp, this.props.history, loginRedirectUrl);
      }).catch(err => this.props.handle2faLoginFailure(err, this.props.history));
    };
    this.switchMethod = () => {
      const {
        token = '',
        isPrimaryMethod,
        switchTwoFactorMethod,
        startRequestingCode,
        finishRequestingCode
      } = this.props;
      if (this.twoFactorMethodIs([TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR, TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR])) {
        startRequestingCode();
        twoFactorDao.challengeTwoFactor(token, !isPrimaryMethod).then(() => {
          finishRequestingCode();
          switchTwoFactorMethod();
        }).catch(err => this.props.handle2faLoginFailure(err, this.props.history));
      } else {
        switchTwoFactorMethod();
      }
    };
    this.retryCode = () => {
      const {
        token = '',
        isPrimaryMethod,
        startRequestingCode,
        finishRequestingCode,
        showNewCodeSentAlert
      } = this.props;
      startRequestingCode();
      twoFactorDao.resendTwoFactor(token, isPrimaryMethod).then(() => {
        finishRequestingCode();
        showNewCodeSentAlert();
      }).catch(err => {
        const responseJSON = err && err.responseText && JSON.parse(err.responseText);
        if (responseJSON && responseJSON.status === 'NEEDS_EMAIL_FALLBACK') {
          const {
            loginPortalId,
            loginRedirectUrl
          } = this.state;
          if (responseJSON && responseJSON.errorTokens && responseJSON.errorTokens.token[0]) {
            this.props.setToken({
              token: responseJSON.errorTokens.token[0]
            });
          }
          let specialBranding = '';
          if (getIsChatSpot()) {
            specialBranding = '&chatspotBranding=true';
          } else if (getIsConnect()) {
            specialBranding = '&connectBranding=true';
          }
          const nextPath = `/confirm-to-login?${stringify({
            loginPortalId,
            loginRedirectUrl
          })}${specialBranding}`;
          this.props.history.push(nextPath);
        } else {
          this.props.handle2faLoginFailure(err, this.props.history);
        }
      });
    };
    this.callForCode = () => {
      const {
        token = '',
        isPrimaryMethod,
        startRequestingTwoFactorCall,
        finishRequestingTwoFactorCall,
        showCodeCallAlert
      } = this.props;
      startRequestingTwoFactorCall();
      twoFactorDao.requestTwoFactorCall(token, isPrimaryMethod).then(() => {
        finishRequestingTwoFactorCall();
        showCodeCallAlert();
      }).catch(err => this.props.handle2faLoginFailure(err, this.props.history));
    };
    this.onReturnToLogin = () => {
      this.props.resetPage();
      this.props.history.push('/');
    };
    this.getCredentials = () => {
      const {
        loginPortalId,
        loginRedirectUrl,
        autoRedirectGoogle
      } = this.state;
      const {
        email,
        password,
        totp = '',
        twoFactorLevel,
        appState,
        token,
        rememberLogin
      } = this.props;
      return {
        email,
        password,
        token,
        verificationCode: totp.replace(/\s+/g, ''),
        loginPortalId,
        loginRedirectUrl,
        autoRedirectGoogle,
        twoFactorLevel: appState === TwoFactorAuthAppStates.DEFAULT ? twoFactorLevel : TwoFactorAuthAppStates.BACKUP,
        rememberLogin
      };
    };
    this.loginHandler = opts => {
      this.props.toggleRememberDeviceModal();
      return this.twoFactorSubmit(opts);
    };
    const {
      search
    } = props.location;
    const query = parseQuery(search.substr(1));
    const {
      autoRedirectGoogle: _autoRedirectGoogle,
      loginPortalId: _loginPortalId,
      loginRedirectUrl: _loginRedirectUrl
    } = extractRedirectQueryParams(query);
    this.state = {
      autoRedirectGoogle: _autoRedirectGoogle,
      loginPortalId: _loginPortalId,
      loginRedirectUrl: _loginRedirectUrl,
      rememberThisDevice: false,
      isUngatedForLoginV4: getIsUngatedForLoginV4()
    };
  }
  componentDidMount() {
    const {
      token
    } = this.props;

    // If they didn't start the flow at /login before getting here,
    // send them to /login
    if (token === null) {
      this.props.history.push('/');
    }
    if (this.twoFactorMethodIs([TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR])) {
      this.startPolling();
      loginVerificationWithHSAuthInitiated();
    }
  }
  render() {
    const {
      twoFactorMethod,
      isVerifying,
      isRequestingCode,
      totp,
      hasSecondaryMethod,
      toggleRememberDevice,
      twoFactorLevel,
      backupCodesEnabled,
      switchAppState,
      appState,
      areBothGoogleAuth
    } = this.props;
    const RememberThisDevice = this.state.isUngatedForLoginV4 ? RememberThisDeviceV4 : RememberThisDeviceV3;
    return /*#__PURE__*/_jsxs(NavMarker, {
      name: "TWO_FACTOR_LOAD",
      children: [/*#__PURE__*/_jsx(RememberThisDevice, {
        onRemember: () => this.loginHandler({
          rememberThisDevice: true
        }),
        onRememberNot: () => this.loginHandler({
          rememberThisDevice: false
        })
      }), /*#__PURE__*/_jsx(TwoFactorAuthForm, {
        isUngatedForLoginV4: this.props.isUngatedForLoginV4,
        twoFactorMethod: twoFactorMethod,
        isVerifying: isVerifying,
        isRequestingCode: isRequestingCode,
        totp: totp,
        hasSecondaryMethod: hasSecondaryMethod,
        onSubmit: e => {
          e.preventDefault();
          this.props.toggleRememberDeviceModal();
        },
        switchVerificationMethod: this.switchMethod,
        retryCode: this.retryCode,
        callForCode: this.callForCode,
        onCodeChange: this.onCodeChange,
        onLostDevice: this.onLostDevice,
        toggleRememberDevice: toggleRememberDevice,
        twoFactorLevel: twoFactorLevel,
        backupCodesEnabled: backupCodesEnabled,
        switchAppState: switchAppState,
        appState: appState,
        areBothGoogleAuth: areBothGoogleAuth,
        onReturnToLogin: this.onReturnToLogin,
        onRestartTimer: this.restartTimer
      })]
    });
  }
}
TwoFactorAuth.propTypes = {
  appState: PropTypes.string,
  backupCodesEnabled: PropTypes.bool.isRequired,
  email: PropTypes.string,
  password: PropTypes.string,
  finishRequestingCode: PropTypes.func.isRequired,
  hasSecondaryMethod: PropTypes.bool.isRequired,
  isPrimaryMethod: PropTypes.bool.isRequired,
  isRequestingCode: PropTypes.bool.isRequired,
  isVerifying: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  rememberThisDevice: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  isUngatedForLoginV4: PropTypes.bool,
  showNewCodeSentAlert: PropTypes.func.isRequired,
  showCodeCallAlert: PropTypes.func.isRequired,
  startRequestingCode: PropTypes.func.isRequired,
  startVerifying: PropTypes.func.isRequired,
  switchAppState: PropTypes.func.isRequired,
  switchTwoFactorMethod: PropTypes.func.isRequired,
  toggleRememberDevice: PropTypes.func.isRequired,
  token: PropTypes.string,
  totp: PropTypes.string,
  twoFactorLevel: PropTypes.string.isRequired,
  twoFactorMethod: PropTypes.object,
  updateTotp: PropTypes.func.isRequired,
  areBothGoogleAuth: PropTypes.bool.isRequired,
  rememberLogin: PropTypes.bool,
  canUseAdminRecovery: PropTypes.bool.isRequired,
  resetPage: PropTypes.func.isRequired,
  handle2faLoginSuccess: PropTypes.func.isRequired,
  handle2faLoginFailure: PropTypes.func.isRequired,
  requestHubspotAppStatus: PropTypes.func.isRequired,
  hubspotAppResponded: PropTypes.bool.isRequired,
  updateHubspotAppStatus: PropTypes.func.isRequired,
  toggleRememberDeviceModal: PropTypes.func.isRequired,
  isLoginWithHSPrompt: PropTypes.bool
};
const mapStateToProps = state => ({
  token: getToken(state),
  twoFactorMethod: getTwoFactorMethod(state),
  isVerifying: getIsVerifying(state),
  isRequestingCode: getIsRequestingCode(state),
  totp: getTotp(state),
  email: getEmail(state),
  password: getPassword(state),
  rememberThisDevice: getRememberThisDevice(state),
  backupCodesEnabled: getBackupCodesEnabled(state),
  appState: getAppState(state),
  isPrimaryMethod: getIsPrimaryMethod(state),
  twoFactorLevel: getTwoFactorLevel(state),
  hasSecondaryMethod: getHasSecondaryMethod(state),
  areBothGoogleAuth: getAreBothGoogleAuth(state),
  rememberLogin: getRememberLogin(state),
  canUseAdminRecovery: true,
  hubspotAppResponded: isHubspotAuthRequestResponded(state),
  isLoginWithHSPrompt: getIsLoginWithHSPrompt(state)
});
const reduxConnect = connect(mapStateToProps, {
  switchTwoFactorMethod: switchTwoFactorMethodAction,
  updateTotp,
  startVerifying,
  finishVerifying,
  startRequestingCode: startRequestingCodeAction,
  startRequestingTwoFactorCall: startRequestingTwoFactorCallAction,
  finishRequestingTwoFactorCall: finishRequestingTwoFactorCallAction,
  finishRequestingCode: finishRequestingCodeAction,
  showNewCodeSentAlert: showNewCodeSentAlertAction,
  showCodeCallAlert: showCodeCallAlertAction,
  toggleRememberDevice: toggleRememberDeviceAction,
  switchAppState: switchAppStateAction,
  resetPage,
  handle2faLoginSuccess,
  handle2faLoginFailure,
  requestHubspotAppStatus,
  updateHubspotAppStatus,
  toggleRememberDeviceModal,
  setToken
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof TwoFactorAuth' is not ass... Remove this comment to see the full error message
export default reduxConnect(TwoFactorAuth);